// extracted by mini-css-extract-plugin
module.exports = {"batchlist":"NJP3WeWm","link":"VtqvP2gx"};